module.exports = __webpack_public_path__ + "img/c.d5cf9619.jpg";